module.exports = __webpack_public_path__ + "static/img/qis.f508b7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qis.png
// module id = UagH
// module chunks = 0